export default __webpack_public_path__ + "static/media/instatChanges.b42e8aa1.gif";